import EditBrandProfileModal from './EditBrandProfileModal.Container';

export default EditBrandProfileModal;
